module.exports = __webpack_public_path__ + "static/media/features-section-background.18beaf05.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sections/Section-Features/assets/features-section-background.png
// module id = 209
// module chunks = 0